<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData" :key="dateKey")
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getSettlement(true)"
          variant="primary"
          size="sm"
        ).mr-2
  .card-body
    .row
      .col-md-10.col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPageSettlementAff($event)")
      .col-md-2.col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSettlementAffSizeSettlementAff" size="sm")
      .col-md-12.col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(rowspan=2 width="3%")
                  span #
                th(rowspan=2 width="9%" @click="sortOrder('settlement_date')")
                  span(:title="$t('ui.settlement_date')" ) {{ $t('ui.settlement_date') }}
                  .float-right
                    i(:class="changeSortKey('settlement_date')")
                th(rowspan=2 width="7%" @click="sortOrder('operator_id')")
                  span(:title="$t('ui.operator_id')" ) {{ $t('ui.operator_id') }}
                  .float-right
                    i(:class="changeSortKey('operator_id')")
                th(rowspan=2 width="7%" @click="sortOrder('account_id')")
                  span(:title="$t('ui.account_id')" ) {{ $t('ui.source') }}
                  .float-right
                    i(:class="changeSortKey('account_id')")
                th(rowspan=2 width="7%" @click="sortOrder('settlement_account_id')")
                  span(:title="$t('ui.settlement_account_id')" ) {{ $t('ui.target') }}
                  .float-right
                    i(:class="changeSortKey('settlement_account_id')")
                th(rowspan=2 width="7%")
                  span(:title="$t('ui.settlement_type')") {{ $t('ui.settlement_type') }}
                //- th.text-center(rowspan=2 width="7%")
                //-   span(:title="$t('ui.carry_over')") {{ $t('ui.carry_over') }}
                th.text-center(colspan=5)
                  span(:title="$t('ui.earning_breakdown')") {{ $t('ui.earning_breakdown') }}
                th.text-right(width="8%" rowspan=2)
                  span(:title="$t('ui.deposit_bonus')") {{ $t('ui.deposit_bonus') }}
                th.text-right(width="8%" rowspan=2)
                  span(:title="$t('ui.total')") {{ $t('ui.total') }}
                th.text-right(width="8%" rowspan=2)
                  span(:title="$t('ui.pnl')") {{ $t('ui.pnl') }}
                  //- i.fas.fa-question-circle.ml-1.text-info(:title="$t('message.tooltips_pnl')")
              tr
                th
                  span &nbsp;
                //- th.text-right(width="8%" @click="sortOrder('to_cockfight')")
                //-   span(:title="$t('ui.cockfight')" ) {{ $t('ui.cockfight') }}
                //-   .float-right
                //-     i(:class="changeSortKey('to_cockfight')")
                th.text-right(width="8%" @click="sortOrder('wl_livecasino')")
                  span(:title="$t('ui.livecasino')" ) {{ $t('ui.livecasino') }}
                  .float-right
                    i(:class="changeSortKey('wl_livecasino')")
                th.text-right(width="8%" @click="sortOrder('wl_slots')")
                  span(:title="$t('ui.slots')" ) {{ $t('ui.slots') }}
                  .float-right
                    i(:class="changeSortKey('wl_slots')")
                th.text-right(width="8%" @click="sortOrder('wl_sports')")
                  span(:title="$t('ui.sportsbook')" ) {{ $t('ui.sportsbook') }}
                  .float-right
                    i(:class="changeSortKey('wl_sports')")
                th.text-right(width="8%" @click="sortOrder('wl_others')")
                  span(:title="$t('ui.others')" ) {{ $t('ui.others') }}
                  .float-right
                    i(:class="changeSortKey('wl_others')")
            tbody.clusterize-content
              tr(v-if="settlementList.length == 0")
                td(colspan="14").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in settlementList")
                tr(@mouseenter="highlightRowspan($event)" @mouseleave="removeHighlight($event)")
                  td(rowspan=3).text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td(rowspan=3).text-left
                    span(:title="$moment(item.settlement_date).format('YYYY-MM-DD')") {{ $moment(item.settlement_date).format("YYYY-MM-DD") }}
                  td(rowspan=3)
                    span(:title="item.operator_id") {{ item.operator_id }}
                  td(rowspan=3)
                    span(:title="item.account_id") {{ item.account_id }}
                  td(rowspan=3)
                    span(:title="item.settlement_account_id") {{ item.settlement_account_id }}
                  td(rowspan=3)
                    span.d-block(:title="item.settlement_type") {{ item.settlement_type }}
                    span
                      i(:class="{'fas fa-check text-info': item.carry_over, 'fas fa-times text-warning': !item.carry_over  }" :title="$t('ui.carry_over')")
                  td.text-left
                    span.small.font-weight-bold.d-block {{ $t('ui.winlose_turnover') }}
                  //- td.text-right
                  //-   span.font-weight-bold.d-block(:title="$n(item.to_cockfight, 'currency')" :class="$helpers.fontClassName(item.to_cockfight)") {{ $n(item.to_cockfight, 'currency') }}
                  td.text-right
                    span.font-weight-bold.d-block(:title="$n(item.wl_livecasino, 'currency')" :class="$helpers.fontClassName(item.wl_livecasino)") {{ $n(item.wl_livecasino, 'currency') }}
                  td.text-right
                    span.font-weight-bold.d-block(:title="$n(item.wl_slots, 'currency')" :class="$helpers.fontClassName(item.wl_slots)") {{ $n(item.wl_slots, 'currency') }}
                  td.text-right
                    span.font-weight-bold.d-block(:title="$n(item.wl_sports, 'currency')" :class="$helpers.fontClassName(item.wl_sports)") {{ $n(item.wl_sports, 'currency') }}
                  td.text-right
                    span.font-weight-bold.d-block(:title="$n(item.wl_others, 'currency')" :class="$helpers.fontClassName(item.wl_others)") {{ $n(item.wl_others, 'currency') }}
                  td.text-right
                    span.font-weight-bold.d-block(:title="$n(item.deposit_bonus, 'currency')" :class="$helpers.fontClassName(item.deposit_bonus)") {{ $n(item.deposit_bonus, 'currency') }}
                  td
                    span &nbsp;
                  td(rowspan=3).text-right
                    span.font-weight-bold(:title="$n(item.pnl, 'currency')" :class="$helpers.fontClassName(item.pnl)") {{ $n(item.pnl, 'currency') }}
                tr(@mouseenter="highlightRowspan($event)" @mouseleave="removeHighlight($event)")
                  td
                    span.small.font-weight-bold.d-block {{ $t('ui.pt') }}
                  //- td.text-right
                  //-   span.font-weight-bold.text-secondary(:title="item.pct_cockfight") ({{ item.pct_cockfight + '%' }}) 
                  //-   span.font-weight-bold(:title="$n(item.earning_cockfight, 'currency')" :class="$helpers.fontClassName(item.earning_cockfight)") {{ $n(item.earning_cockfight, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_livecasino") ({{ item.pct_livecasino + '%' }}) 
                    span.font-weight-bold(:title="$n(item.earning_livecasino, 'currency')" :class="$helpers.fontClassName(item.earning_livecasino)") {{ $n(item.earning_livecasino, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_slots") ({{ item.pct_slots + '%' }}) 
                    span.font-weight-bold(:title="$n(item.earning_slots, 'currency')" :class="$helpers.fontClassName(item.earning_slots)") {{ $n(item.earning_slots, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_sports") ({{ item.pct_sports + '%' }}) 
                    span.font-weight-bold(:title="$n(item.earning_sports, 'currency')" :class="$helpers.fontClassName(item.earning_sports)") {{ $n(item.earning_sports, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_others") ({{ item.pct_others + '%' }}) 
                    span.font-weight-bold(:title="$n(item.earning_others, 'currency')" :class="$helpers.fontClassName(item.earning_others)") {{ $n(item.earning_others, 'currency') }}
                  td 
                    span &nbsp;
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.earning_total" :class="$helpers.fontClassName(item.earning_total)") {{ $n(item.earning_total, 'currency') }}                          
                tr(@mouseenter="highlightRowspan($event)" @mouseleave="removeHighlight($event)")
                  td
                    span.small.font-weight-bold.d-block {{ $t('ui.cost') }}
                  //- td.text-right
                  //-   span.font-weight-bold.text-secondary(:title="item.pct_platform") ({{ item.pct_platform + '%' }}) 
                  //-   span.font-weight-bold.text-danger(:title="$n(item.cost_cockfight, 'currency')" :class="$helpers.fontClassName(item.cost_cockfight, true)") {{ $n(item.cost_cockfight, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_platform") ({{ item.pct_platform + '%' }}) 
                    span.font-weight-bold.text-danger(:title="$n(item.cost_livecasino, 'currency')" :class="$helpers.fontClassName(item.cost_livecasino, true)") {{ $n(item.cost_livecasino, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_platform") ({{ item.pct_platform + '%' }}) 
                    span.font-weight-bold.text-danger(:title="$n(item.cost_slots, 'currency')" :class="$helpers.fontClassName(item.cost_slots, true)") {{ $n(item.cost_slots, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_platform") ({{ item.pct_platform + '%' }}) 
                    span.font-weight-bold.text-danger(:title="$n(item.cost_sports, 'currency')" :class="$helpers.fontClassName(item.cost_sports, true)") {{ $n(item.cost_sports, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_platform") ({{ item.pct_platform + '%' }})
                    span.font-weight-bold.text-danger(:title="$n(item.cost_others, 'currency')" :class="$helpers.fontClassName(item.cost_others, true)") {{ $n(item.cost_others, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_platform") ({{ item.pct_slots + '%' }}) 
                    span.font-weight-bold.text-danger(:title="$n(item.cost_deposit_bonus, 'currency')" :class="$helpers.fontClassName(item.cost_deposit_bonus, true)") {{ $n(item.cost_deposit_bonus, 'currency') }}
                  td.text-right
                    span.font-weight-bold.text-secondary(:title="item.pct_platform")
                    span.font-weight-bold.text-danger(:title="$n(item.cost_total, 'currency')" :class="$helpers.fontClassName(item.cost_total, true)") {{ $n(item.cost_total, 'currency') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    settlementList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    endDate: null,
    dateRange: {
      startDate: null,
      endDate: null
    },
    localeDate: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "working_date",
    // sortKey: "created_date",
    sortType: "desc",
    dateKey: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
  },
  mounted: function() {
    // this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    // this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
  },
  methods: {
    refresh() {
      this.dateKey += 1;
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.getSettlement(true);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getSettlement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getSettlement(true);
    },
    getSettlement: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.settlementListAffUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          account_id: this.affiliateID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.settlementList = response.data.dt;
                  this.totalRow = this.settlementList.length > 0 ? this.settlementList[0].totalrows : 0;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              // console.log(error)
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.settlementList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSettlementAffSizeSettlementAff: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSettlement(true);
    },
    changedPageSettlementAff: function(pageNo) {
      this.currentPage = pageNo;
      this.getSettlement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    highlightRowspan(event) {
      // Find the <tr> where the hover originated
      let row = event.currentTarget;

      // Search upward for the <td> with rowspan (if any)
      while (row) {
        const rowspanCell = row.querySelector("td[rowspan]");
        if (rowspanCell) {
          const rowspan = parseInt(rowspanCell.getAttribute("rowspan"), 10);
          let currentRow = row;

          // Highlight all rows spanned by the rowspan cell
          for (let i = 0; i < rowspan; i++) {
            if (currentRow) {
              currentRow.classList.add("highlight");
              currentRow = currentRow.nextElementSibling; // Move to the next row
            }
          }
          break;
        }
        row = row.previousElementSibling; // Move to the previous row to find the parent
      }
    },
    removeHighlight(event) {
      // Find the <tr> where the hover originated
      let row = event.currentTarget;

      // Search upward for the <td> with rowspan (if any)
      while (row) {
        const rowspanCell = row.querySelector("td[rowspan]");
        if (rowspanCell) {
          const rowspan = parseInt(rowspanCell.getAttribute("rowspan"), 10);
          let currentRow = row;

          // Remove highlight from all rows spanned by the rowspan cell
          for (let i = 0; i < rowspan; i++) {
            if (currentRow) {
              currentRow.classList.remove("highlight");
              currentRow = currentRow.nextElementSibling; // Move to the next row
            }
          }
          break;
        }
        row = row.previousElementSibling; // Move to the previous row to find the parent
      }
    },
  }
};
</script>

<style scoped>
/* Default Bootstrap striped rows */
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f8f9fa;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}

/* Highlight class */
.highlight {
  background-color: #f0f8ff !important; /* Your hover color */
}
</style>